import React, { useEffect, useState } from "react";
import { Download, WifiOff, X } from "lucide-react";

export const PwaStatus = () => {
  const [prompt, setPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("cw-install-dismissed") === "1");
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  const install = async () => {
    prompt.prompt();
    await prompt.userChoice;
    setPrompt(null);
  };

  const dismiss = () => { localStorage.setItem("cw-install-dismissed", "1"); setDismissed(true); };

  return (
    <>
      {offline && (
        <div className="flex items-center justify-center gap-2 py-2 text-xs font-medium text-white" style={{ background: "var(--mf-accent)" }} data-testid="offline-banner">
          <WifiOff className="w-3.5 h-3.5" /> You're offline — showing cached app. Changes will need a connection.
        </div>
      )}
      {prompt && !dismissed && (
        <div className="mx-5 md:mx-8 mt-3 flex items-center gap-3 px-4 py-3 rounded-2xl mf-fade-in" style={{ background: "var(--mf-surface)" }} data-testid="install-banner">
          <img src="/icons/icon-192.png" alt="" className="w-9 h-9 rounded-xl" />
          <div className="flex-1 text-sm" style={{ color: "var(--mf-text)" }}>Install Clinician Well for one-tap access on this device.</div>
          <button onClick={install} className="mf-btn-primary flex items-center gap-1.5 text-sm" data-testid="install-app-btn">
            <Download className="w-4 h-4" /> Install
          </button>
          <button onClick={dismiss} className="p-1.5 rounded-lg hover:bg-black/5" aria-label="Dismiss" data-testid="install-dismiss-btn">
            <X className="w-4 h-4" style={{ color: "var(--mf-text-muted)" }} />
          </button>
        </div>
      )}
    </>
  );
};
